module.exports = __webpack_public_path__ + "media/images/default_card_image-df613bd9bb34b8e7aed9c22e9c2d985e.jpg";